// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"OrderDetailsGrid_gridContainer__2hPz8","gridOverlay":"OrderDetailsGrid_gridOverlay__2fZBw"};